


























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";

export default defineComponent({

	setup(props, context){
		
		const { translate } = useTranslate(context);

		const buttonText = computed(() => {
			return translate("continue").toUpperCase();
		});
		
		return {
			buttonText
		};
	}
});
